import _ from 'lodash';
import React from 'react';
import {Modal} from 'semantic-ui-react';

import Loading from '../loading';
import './index.css';

export class ChatedModal extends React.Component {
	componentWillMount () {
		this.setState( {
			open        : false,
			modalHeader : '.',
			modalBody   : '',
			modalFooter : ''
		} );
	}

	/* used to handle input */
	onChangeField = (e, obj) => {
		this.setState({
			[obj.name] : obj.value
		});
	}
	onChangeDate = (key, value) => {
		if (_.isNil(value) || _.isString(value)) {
			this.setState({
				[key]: ''
			});
		} else {
			this.setState({
				[key]: value.format('YYYY-MM-DD')
			});
		}
	}
	/* used to handle input */

	/**
	 * Open modal
	 *
	 */
	openModal = () => {
		this.setState({open: true});
	}

	/**
	 * Close modal
	 *
	 */
	hideModal = () => {
		this.setState({open: false});
	}

	/**
	 * Append element in modal
	 *
	 */
	appendElement = ( header, body, footer ) => {
		this.setState({
			modalHeader: header || ' ',
			modalBody: body,
			modalFooter: footer
		});
	}

	/*
	 * Open image in new window
	 * @param (string) - base64 image string
	 */
	openImageInNewWindow(imageString) {
		if (imageString) {
			const image = new window.Image();
			image.src = imageString;
			image.style.maxWidth = '900px';
			const w = window.open('');
			w.document.write(image.outerHTML);
		}
	}

	/*
	 * Convert binary image to base 64 string
	 * @param (binary) - binary image
	 */
	getBase64StringFromImage(image) {
		if (image) {
			const urlCreator = window.URL || window.webkitURL;
			return urlCreator.createObjectURL(this.state.image);
		} else {
			return null;
		}
	}

	render () {
		return (
			<Modal open={ this.state.open } closeIcon onClose={ this.hideModal }>
				<Modal.Header>{ this.state.modalHeader }</Modal.Header>
				<Modal.Content><div className='content-wrapper'>{ this.state.modalBody }</div></Modal.Content>
				<Modal.Actions>{ this.state.modalFooter }</Modal.Actions>
			</Modal>
		);
	}

	renderLoadingModal () {
		return (
			<Modal open={ this.state.open } closeIcon onClose={ this.hideModal }>
				<Modal.Header></Modal.Header>
				<Modal.Content>
					<Loading />
				</Modal.Content>
				<Modal.Actions></Modal.Actions>
			</Modal>
		);
	}
}

export default ChatedModal;



// WEBPACK FOOTER //
// ./src/components/modal/index.js